import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Phone } from 'lucide-react';
import { ksbData } from '../data/ksb';
import PDFModal from '../components/PDFModal';
import './KSB.css';

const KSB = () => {
  const navigate = useNavigate();
  const [pdfModal, setPdfModal] = useState(null);
  const whatsappNumber = '5493413047536';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=¡Hola!%20Quiero%20consultar%20sobre%20productos%20KSB`;

  const pageData = ksbData.ksb;

  return (
    <>
    <div className="ksb-container" data-testid="ksb-page">
      {/* Hero Section */}
      <section className="ksb-hero">
        <div className="ksb-hero-content">
          <h1 className="ksb-hero-title">KSB</h1>
          {pageData.intro.map((text, idx) => (
            <p key={idx} className="ksb-hero-description">{text}</p>
          ))}
        </div>
      </section>

      {/* Cards Section */}
      <section className="ksb-cards-section">
        <div className="container">
          <div className="ksb-cards-grid">
            {pageData.sections[0].cards.map((card, idx) => (
              <Card
                key={idx}
                className="ksb-card"
                data-testid={`card-${card.title.toLowerCase().replace(/\s+/g, '-').replace(/[()]/g, '')}`}
                onClick={() => {
                  if (card.isPdfModal) setPdfModal({ url: card.href, title: card.title });
                  else navigate(card.href);
                }}
              >
                <CardContent className="ksb-card-content">
                  <div className="ksb-card-image">
                    <img
                      src={card.image}
                      alt={card.title}
                      className="card-image"
                    />
                  </div>
                  <h3 className="ksb-card-title">{card.title}</h3>
                  <p className="ksb-card-description">{card.description}</p>
                  <span className="ksb-card-arrow">→</span>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="ksb-cta-section">
        <div className="container">
          <p className="ksb-cta-text">
            Representamos tecnología que potencia la eficiencia y confiabilidad de tus procesos.
          </p>
          <Button 
            size="lg" 
            className="ksb-cta-button"
            onClick={() => window.open(whatsappLink, '_blank')}
            data-testid="ksb-contact-button"
          >
            <Phone className="mr-2" size={20} />
            ¡Contactanos!
          </Button>
        </div>
      </section>
    </div>

    {pdfModal && (
      <PDFModal
        pdfUrl={pdfModal.url}
        title={pdfModal.title}
        onClose={() => setPdfModal(null)}
      />
    )}
    </>
  );
};

export default KSB;
